import React from 'react';

import PropTypes from 'prop-types';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const CancelSubscriptionPopup = (props) => {
    return (
        <SimplePopup popupRef={props.popupRef} text={props.text}>
            <PopupButton
                type="button"
                iconName="cross-rounded"
                text={props.buttonText}
                onClick={() => {
                    props.submitRef.current?.click();
                    props.popupRef.current?.close();
                }}
                isAlertButton
            />
        </SimplePopup>
    );
};
CancelSubscriptionPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    submitRef: PropTypes.shape({ current: PropTypes.object }),
    text: PropTypes.string,
    buttonText: PropTypes.string,
};
export default CancelSubscriptionPopup;
